<template>
  <ClientOnly>
    <el-dialog
      v-model="visible"
      v-bind="$attrs"
      align-center
      :show-close="showClose"
      modal-class="base-dialog">
      <template #header> {{ title }} </template>
      <slot name="content"></slot>
      <template #footer v-if="isFooterVisible">
        <div class="dialog-footer">
          <div @click="emits('onCancel')" class="cancel-btn">
            {{ cancelTxt || $t('selfRepair.btn_cancel') }}
          </div>
          <div @click="emits('onConfirm')" class="confirm-btn">
            {{ confirmTxt || $t('selfRepair.btn_confirm') }}
          </div>
        </div>
      </template>
    </el-dialog>
  </ClientOnly>
</template>
<script setup lang="ts">
const emits = defineEmits(['onConfirm', 'onCancel']);
const visible = ref(true);
const props = defineProps({
  confirmTxt: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  cancelTxt: {
    type: String,
    default: ''
  },
  isFooterVisible: {
    type: Boolean,
    default: true
  },
  showClose: {
    type: Boolean,
    default: false
  }
});
</script>
<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: space-between;
}
.cancel-btn,
.confirm-btn {
  width: calc(50% - 10px);
  height: 40px;
  line-height: 40px;
  color: #1e253dff;
  border: 1px solid #1d2226;
  font-size: 18px;
  font-weight: 500;
  border-radius: 5px 5px 5px 5px;
  text-align: center;
  cursor: pointer;
}
.confirm-btn {
  background: #1d2226;
  color: #ffffff;
}
</style>
<style lang="scss">
.base-dialog {
  .el-dialog {
    --el-dialog-border-radius: 10px;
    --el-dialog-padding-primary: 20px;
    padding: 30px 30px 20px;
  }
  .el-dialog__header {
    font-weight: 500;
    font-size: 24px;
    color: #000000;
    line-height: 30px;
    text-align: center;
  }
  .el-dialog__footer {
    padding: 0;
  }
}
</style>
